import React, { useEffect, useState } from 'react';
import scene from "../styles/Scene.module.css";
import Header from '../components/Header/Header';
import Header2 from '../components/Header/Header2';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import classes from "../styles/Subscription.module.css";
import { FaCopyright } from "react-icons/fa";
import { loginApi } from '../http/http';
import Cookies from "js-cookie";
import {toast} from "react-toastify";

const LoginPage = () => {
    const [query, setQuery] = useState("");
    const [offsets, setOffsets] = useState({ cloudsX: 0, cloudsY: 0, hillsY: 0 });

    const [searchParams, setSearchParams] = useSearchParams();
    const [extRef, setExtRef] = useState(null);
    const navigate = useNavigate();
    const [loading,setLoading]=useState(false);

    const [msisdn, setMsisdn] = useState("");

    useEffect(() => {
        if (searchParams.get("ext_id")) {
            setExtRef(searchParams.get("ext_id"));
        } else {
            setSearchParams({ ext_id: uuidv4() });
        }
    }, [searchParams]);

    useEffect(() => {
        const onScroll = () => {
            const y = window.scrollY;
            setOffsets({ cloudsX: -(y * 0.1), cloudsY: (y * 0.05), hillsY: -(y * 0.08) });
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    const handleSubscription = () => {
        window.location.href = `https://ng-app.com/Rainboo/KidzMania-24-No-23410220000026648-web?trxId=${extRef}`
    }

    const handleLogin = async () => {
        try {
            setLoading(true);
            const response = await loginApi(msisdn);
            console.log(response?.data, 'response===');
            
            setLoading(false);

            if(response?.data?.result?.statusCode==200){
                console.log("Success====");
                toast.success(response?.data?.result?.message);
                Cookies.set("msisdn",response?.data?.result?.msisdn);
                navigate("/home");
                
            }
            else if(response?.data?.result?.statusCode==400){
                toast.warn(response?.data?.result?.message);
                console.log("Low Balance===");
            }
            else if(response?.data?.result?.statusCode==403){
                console.log("You are not subscribed!");
                toast.error(response?.data?.result?.message);
            }
            else{
                toast.error("Something Went Wrong!");
            }
        } catch (error) {
            toast.error("Something Went Wrong!");
            setLoading(false);
            console.log(error, "error");
        }
    }

    return (
        <div className={scene.scene}>
            {/* Parallax layers */}
            <div className={`${scene.layer} ${scene.sun}`} style={{ transform: `translateY(${offsets.hillsY * 0.4}px)` }} />
            <div className={`${scene.layer} ${scene.clouds}`} style={{ backgroundPosition: `${offsets.cloudsX}px ${40 + offsets.cloudsY}px` }} />
            <div className={`${scene.layer} ${scene.hills}`} style={{ transform: `translateY(${offsets.hillsY}px)` }} />

            <Header2 />

            <main className={scene.container}>


                <div className={scene.subscription_container}>
                    <section className={classes.section_landing_page}>
                        <div className={classes.grid_container}>
                            <div className={classes.grid_section_one}>
                                <div className={classes.form}>

                                    {/* <div className={classes.landingPageBanner}>
                                        <img src="assets/images/banner.png" alt="Banner" className={classes.banner} />
                                    </div> */}

                                    <div className={scene.card}>
                                        <div className={`${scene.bubble} ${scene.b1}`} />
                                        <div className={`${scene.bubble} ${scene.b2}`} />
                                        <div className={`${scene.bubble} ${scene.b3}`} />
                                        <h1 className={scene.title}>Welcome to KidsMania 👋</h1>
                                        <p className={scene.sub}>
                                            {/* Colorful rhymes, playful learning, and cozy stories — all in one cheerful place. Safe, simple, and fun! */}
                                            Online educational platform for digital skills where students aged between 2-10 learn through fun and interactive videos
                                        </p>
                                        <div className="pill" style={{ marginTop: 10, position: "relative", zIndex: 2 }}>✨ Please Login Now ❤</div>
                                        <input type='number' placeholder='Enter your Number' value={msisdn} onChange={(e) => setMsisdn(e.target.value)}
                                            className={classes.input}
                                            autoFocus
                                            style={{ marginTop: "14px", zIndex: 999, position: 'relative' }}
                                        />
                                        <button className={classes.login_btn} id="subscribe_btn" onClick={() => handleLogin()}
                                            disabled={loading}
                                            style={{ marginTop: "14px", zIndex: 999, position: 'relative' }}
                                        >
                                            {loading ? <div className={classes.spinner}>

                                            </div> : "Login"}
                                            
                                        </button>
                                    </div>


                                    <div className={classes.grid_or_container}>
                                        <span className={classes.grid_item}></span>
                                        <span className={classes.or}>Or</span>
                                        <span className={classes.grid_item}></span>
                                    </div>

                                    <button className={classes.login_btn} onClick={() => handleSubscription()}
                                        style={{ background: "black" }}

                                    >
                                        Subscribe Now
                                    </button>

                                </div>


                                {/* <div className={classes.termsSection}>
                                <h1 className={classes.termsHeading}>Terms & Conditions</h1>
                                <ul className={classes.termsList}>
                                    <li>The service cost is KSH 15/day.</li>
                                    <li>Your Subscription will be renewed at KSH 15/day, automatically until you unsubscribe.</li>
                                    <li>You can unsubscribe from the service anytime, by dialling USSD code *xxx# or deactivating from the portal.</li>
                                    <li>All data-enabled features & Smartphone users can enjoy full service.</li>
                                    <li>Customer can access the content at any time during the subscription validity period.</li>
                                </ul>
                            </div> */}

                            </div>
                            <div className={classes.grid_section_two}>
                                <img src="/assets/images/kids-group.png" alt="kids-group" className={classes.kids_group_image} />


                                <p className={classes.portal_description}>
                                    Online educational platform for digital skills where students aged between 2-10 learn through fun and interactive videos
                                </p>

                                <div className={classes.grid_sub_container}>
                                    <div className={classes.kids_image_container}>
                                        <img src="/assets/images/kids.png" alt="kids" className={classes.kids_image} />
                                    </div>
                                    <div className={classes.kids_info}>
                                        <p className={classes.kids_info_text_one}>Made For</p>
                                        <p className={classes.kids_info_text_two}>- Kids</p>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <img src="/assets/images/Union.png" alt="union" className={classes.union_image} />
                        <img src="/assets/images/learning.png" alt="union" className={classes.learning_image} />

                    </section>

                    <section className={classes.footer}>
                        <div className={classes.container}>
                            <div className={classes.footer_container}>

                                <div className={classes.copyright_container}>
                                    <FaCopyright className={classes.copyright_icon} />
                                    <p className={classes.copyright_text}>
                                        Rainboo Softmate Pvt Ltd
                                    </p>
                                </div>
                            </div>


                        </div>
                    </section>

                </div>


            </main>
        </div>
    )
}

export default LoginPage